class MoonCalculator {
  constructor() {
    this.setStepLabels()
    eventBus.on('variant:change', this.setStepLabels);
  }

  setStepLabels() {
    const stepLabels = document.querySelectorAll('[data-calculator-step]')
    stepLabels?.forEach((label, i) => {
      label.setAttribute('data-calculator-step', i+1)
    })
  }

  static getMonthName(month) {
    // Map months to their names
    const months = {
      1: "January",
      2: "February",
      3: "March",
      4: "April",
      5: "May",
      6: "June",
      7: "July",
      8: "August",
      9: "September",
      10: "October",
      11: "November",
      12: "December"
    };

    return months[month] || "Unknown";  // Return the month name or 'Unknown' if month is invalid
  }

  static async fetchCalendarData(targetDate) {
    try {
      const response = await fetch('https://cdn.shopify.com/s/files/1/0644/7238/3733/files/calendar-data.json');
      if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const rawData = await response.text();

        try {
            const jsonData = JSON.parse(rawData);
            // Define the date you're searching for

            // if target date first char is 0, remove it
            if (targetDate.charAt(0) === '0') {
              targetDate = targetDate.slice(1);
            }

            // Check if the date exists in the JSON object
            if (jsonData.hasOwnProperty(targetDate)) {
              // this.moonphase.innerText = jsonData[targetDate];
              return jsonData[targetDate];
            } else {
              console.log(`No event found for date: ${targetDate}`);
            }
        } catch (jsonError) {
            console.error('Error parsing JSON:', jsonError);
        }

    } catch (error) {
        console.error('There has been a problem with your fetch operation:', error);
    }
  }

  static getZodiacSign(day, month) {
    // Zodiac signs and date ranges
    if ((month == 3 && day >= 21) || (month == 4 && day <= 19)) {
        return "Aries";
    } else if ((month == 4 && day >= 20) || (month == 5 && day <= 20)) {
        return "Taurus";
    } else if ((month == 5 && day >= 21) || (month == 6 && day <= 20)) {
        return "Gemini";
    } else if ((month == 6 && day >= 21) || (month == 7 && day <= 22)) {
        return "Cancer";
    } else if ((month == 7 && day >= 23) || (month == 8 && day <= 22)) {
        return "Leo";
    } else if ((month == 8 && day >= 23) || (month == 9 && day <= 22)) {
        return "Virgo";
    } else if ((month == 9 && day >= 23) || (month == 10 && day <= 22)) {
        return "Libra";
    } else if ((month == 10 && day >= 23) || (month == 11 && day <= 21)) {
        return "Scorpio";
    } else if ((month == 11 && day >= 22) || (month == 12 && day <= 21)) {
        return "Sagittarius";
    } else if ((month == 12 && day >= 22) || (month == 1 && day <= 19)) {
        return "Capricorn";
    } else if ((month == 1 && day >= 20) || (month == 2 && day <= 18)) {
        return "Aquarious";
    } else if ((month == 2 && day >= 19) || (month == 3 && day <= 20)) {
        return "Pisces";
    }
    return null; // In case the date is invalid
  }

  static getZodiacElement(zodiacSign) {
    // Map zodiac signs to their elements
    const elements = {
      Aries: "Fire",
      Leo: "Fire",
      Sagittarius: "Fire",
      Taurus: "Earth",
      Virgo: "Earth",
      Capricorn: "Earth",
      Gemini: "Air",
      Libra: "Air",
      Aquarious: "Air",
      Cancer: "Water",
      Scorpio: "Water",
      Pisces: "Water"
    };

    return elements[zodiacSign] || "Unknown";
  }

  static getZodiacElementFromDate(day, month) {
      const zodiacSign = MoonCalculator.getZodiacSign(day, month);

      if (zodiacSign) {
          const element = MoonCalculator.getZodiacElement(zodiacSign);
          return {
            zodiacSign: zodiacSign,
            element: element
          }
      } else {
          console.log("Invalid date");
          return null;
      }
  }

  static getMoonPhaseName(phase) {
    const moonPhases = {
      "NM":"New Moon",
      "1WX":"Waxing Crescent",
      "2WX":"Waxing Crescent",
      "3WX":"Waxing Crescent",
      "4WX":"Waxing Crescent",
      "FQ":"First Quarter",
      "5WX":"Waxing Gibbous",
      "6WX":"Waxing Gibbous",
      "7WX":"Waxing Gibbous",
      "8WX":"Waxing Gibbous",
      "FM":"Full Moon",
      "1WN":"Waning Gibbous",
      "2WN":"Waning Gibbous",
      "3WN":"Waning Gibbous",
      "4WN":"Waning Gibbous",
      "LQ":"Last Quarter",
      "5WN":"Waning Crescent",
      "6WN":"Waning Crescent",
      "7WN":"Waning Crescent",
      "8WN":"Waning Crescent"
    };

    return moonPhases[phase] || "Unknown";
  }

  static getBirthstone(month) {
    // Map months to their respective birthstones
    const birthstones = {
        1: "Garnet",             // January
        2: "Amethyst",           // February
        3: "Aquamarine",         // March
        4: "Diamond",            // April
        5: "Emerald",            // May
        6: "Pearl or Alexandrite",// June
        7: "Ruby",               // July
        8: "Peridot",            // August
        9: "Sapphire",           // September
        10: "Opal or Tourmaline",// October
        11: "Topaz or Citrine",  // November
        12: "Turquoise or Blue Topaz" // December
    };

    return birthstones[month] || "Unknown";  // Return the birthstone or 'Unknown' if month is invalid
  }

  static getBirthstoneFromDate(month) {
    const birthstone = MoonCalculator.getBirthstone(month);
    if (birthstone) {
      return birthstone;
    } else {
      console.log("Invalid date");
      return null;
    }
  }
}
const moonCalculator = new MoonCalculator();